import { watch } from 'vue';
import { useI18n } from 'vue-i18n';
import { mergeSeoKeywords } from '../seo/seoKeywords';

function setMeta(name: string, content: string) {
  let el = document.querySelector(`meta[name="${name}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute('name', name);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}

export function useDocumentMeta() {
  const { t, locale } = useI18n();

  function apply() {
    const suffix = import.meta.env.VITE_DEPLOY_ENV === 'development' ? ' (Dev)' : '';
    document.title = t('meta.title') + suffix;
    document.documentElement.lang = locale.value;
    setMeta('keywords', mergeSeoKeywords(t('meta.keywords')));
    setMeta('description', t('meta.description'));
  }

  watch(() => locale.value, apply, { immediate: true });
}
